module.exports = {"version":2,"waiters":{"IdentityExists":{"delay":3,"operation":"GetIdentityVerificationAttributes","maxAttempts":20,"acceptors":[{"expected":"Success","matcher":"pathAll","state":"success","argument":"VerificationAttributes.*.VerificationStatus"}]}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/email-2010-12-01.waiters2.json
// module id = 2333
// module chunks = 0